import { render } from "./DemoAccessModal.vue?vue&type=template&id=1abb266c&scoped=true"
import script from "./DemoAccessModal.vue?vue&type=script&lang=js"
export * from "./DemoAccessModal.vue?vue&type=script&lang=js"

import "./DemoAccessModal.vue?vue&type=style&index=0&id=1abb266c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abb266c"]])

export default __exports__